import { render, staticRenderFns } from "./IframeContainer.vue?vue&type=template&id=5a6e1060&scoped=true&"
import script from "./IframeContainer.vue?vue&type=script&lang=js&"
export * from "./IframeContainer.vue?vue&type=script&lang=js&"
import style0 from "./IframeContainer.vue?vue&type=style&index=0&id=5a6e1060&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6e1060",
  null
  
)

export default component.exports